import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import BaseDialog from 'core/components/base-dialog/base-dialog';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';

import useStyles from './verify-roof-year-learn-more-modal.styles';

const VerifyRoofYearLearnMoreModal = ({ open, onClose, data }) => {
  const classes = useStyles();
  const { roofYear, roofReplacementYearMax } = data || {};

  return (
    <BaseDialog open={open} onClose={onClose} classes={{ paper: classes.container }}>
      <Label type="greenBig" className={classes.modalHeader}>
        Verify roof year
      </Label>

      <div className={classes.section}>
        <Label type="body" className={classes.sectionContent}>
          Since the home's roof year provided is newer than the year shown by Branch's data, we'll need acceptable proof
          to verify it.
        </Label>
        <Label type="body" className={classes.sectionContent}>
          Roof year from trusted data source: <strong>{roofReplacementYearMax}</strong>
        </Label>
        <Label type="body" className={classes.sectionContent}>
          Roof year from policy: <strong>{roofYear}</strong>
        </Label>
      </div>

      <div className={classes.section}>
        <Label type="darkGreenSmall" className={classes.sectionTitle}>
          Where do we get roof year data from?
        </Label>
        <Label type="body" className={classes.sectionContent}>
          Branch uses aerial imagery, changes detection algorithms, and permit data to determine roof replacement dates
          with industry-leading accuracy.
        </Label>
      </div>

      <div className={classes.section}>
        <Label type="darkGreenSmall" className={classes.sectionTitle}>
          What counts as proof of replacement?
        </Label>
        <ul className={classes.list}>
          <li>
            <Label type="body">Paid invoice</Label>
          </li>
          <li>
            <Label type="body">Signed contract showing work completed date</Label>
          </li>
          <li>
            <Label type="body">For newly purchased homes only: roof replacement permits or seller's disclosures</Label>
          </li>
        </ul>
      </div>

      <Grid className={classes.btnContainer}>
        <Button variant="contained" color="primary" className={classes.closeBtn} onClick={onClose}>
          Close
        </Button>
      </Grid>
    </BaseDialog>
  );
};

VerifyRoofYearLearnMoreModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    roofYear: PropTypes.number,
    roofReplacementYearMax: PropTypes.number
  })
};

VerifyRoofYearLearnMoreModal.defaultProps = {
  data: {}
};

export default VerifyRoofYearLearnMoreModal;
